import type { IUploadStore } from "./UploadStore";
import type { IUploadCodeAndSourceSelectionStore } from "./content/upload-code-and-source-selection/UploadCodeAndSourceSelectionStore";
import type { IAppStores } from "../shared-components/AppStores";
import type { IDicomUploadTusFingerprintStore } from "./DicomUploadTusFingerprintStore";
import type { ICurrentUploadSettingsStore } from "./CurrentUploadSettingsStore";
import type { IApp } from "../shared-components/App";

export interface IAppUpload extends IApp {
    stores: IUploadStores;
}

export class AppUpload implements IAppUpload {
    constructor(public readonly stores: IUploadStores) {}
}

export interface IUploadStores extends IAppStores {
    uploadStore: IUploadStore;
    uploadCodeAndSourceSelectionStore: IUploadCodeAndSourceSelectionStore;
    dicomUploadTusFingerprintStore: IDicomUploadTusFingerprintStore;
    currentUploadSettingsStore: ICurrentUploadSettingsStore;
}
